import React, { useEffect, useLayoutEffect, useState, useRef, useContext } from 'react';
import { useWindowSize } from '@react-hook/window-size';
import { ReactComponent as Bkp } from './assets/images/bkp.svg';
import { PostsList, Map } from './components/index';
import { useDispatch } from "react-redux";
import { getPosts } from './actions/posts';
import { ReactSVGPanZoom } from 'react-svg-pan-zoom';
import {
    IdElementContext,
} from './context';

const App = () => {

  // set curent ID on Map and update selected ilot (swiper) and post
  // const { setIdElement } = useSharedIdElement();

  // const [activeElement, setActiveElement] = useState(1)
  // const activeElementContext = React.createContext(activeElement);

  const { IdElement, setIdElement } = useContext(IdElementContext);
  

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts())
  }, [dispatch])

  const Viewer = useRef(null);
  const [tool, onChangeTool] = useState('auto')
  const [value, onChangeValue] = useState('auto')
  const [width, height] = useWindowSize()

  useLayoutEffect(() => {
    Viewer.current.fitToViewer();
    //Centre et Zoom le svg au chargement de la page 
    Viewer.current.zoom(width / 2, height / 2, 1.5);
  }, []);

  return (
    <>
      <div className="App _relative _overflow-hidden">
        <a href="https://lab.be-keeper.com/" target="_blank" rel="noopener noreferrer">
          <Bkp className="_absolute _top-none _m-xs _z-50 _opacity-90" style={{ width: '50px'}}/>
        </a>
        <div style={{width: "100%", height: "100%"}}>
          <ReactSVGPanZoom
            miniatureProps={{
              position: 'none'
            }}
            toolbarProps={{
              position: 'none'
            }}
            background='#fff'
            detectAutoPan={false}
            //Hauteur de la fenetre moins le footer
            width={width} height={height - 60}
            ref={Viewer}
            value={value} onChangeValue={onChangeValue}
            tool={tool} onChangeTool={onChangeTool}
            scaleFactorMin={1.8}
            onClick={(event) => {
              if (event.originalEvent.target.parentNode.id) {
                setIdElement(parseInt(event.originalEvent.target.parentNode.id))
                }
              }
            }
            onTouchEnd={(event) => {
                  if (event.originalEvent.target.parentNode.id) {
                  setIdElement(parseInt(event.originalEvent.target.parentNode.id))
                }
              }
            }
             
            >
            <svg width={width} height={height}>
              <Map isSelected={IdElement}/>
            </svg>
          </ReactSVGPanZoom>
        </div>
        <div className="_fixed _w-full" style={{ bottom: '74px' }}>
          <PostsList indexElement={IdElement}/>
        </div>
      </div>
    </>
  );
}

export default App;
